import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const required = (value) => (value ? undefined : 'Required');

const TypeOfLicense = ({ values, onChange }) => (
  <Content>
    {({
      selectListError,
      typeOfLicense,
      licenceFCA = 'licenceFCA',
      licenceGambling = 'licenceGambling',
      licenceHMRC = 'licenceHMRC',
      licenceSolicitors = 'licenceSolicitors',
      licenceOther = 'licenceOther',
      licenceFCAValue = 'licenceFCAValue',
      licenceGamblingValue = 'licenceGamblingValue',
      licenceHMRCValue = 'licenceHMRCValue',
      licenceSolicitorsValue = 'licenceSolicitorsValue',
      licenceOtherValue = 'licenceOtherValue'
    }) => (
      <Field name="typeOfLicense" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="typeOfLicense"
            title={typeOfLicense}
            validationMessage={touched && !!error && selectListError}
          >
            <Field name="typeOfLicense" validate={required}>
              {({ input }) => (
                <GenericRadio.StackedSet
                  groupName="typeOfLicense"
                  selectedId={values.typeOfLicense}
                  items={[
                    { id: licenceFCAValue, labelText: licenceFCA },
                    { id: licenceGamblingValue, labelText: licenceGambling },
                    { id: licenceHMRCValue, labelText: licenceHMRC },
                    { id: licenceSolicitorsValue, labelText: licenceSolicitors },
                    { id: licenceOtherValue, labelText: licenceOther }
                  ]}
                  onChange={(selectedId) => {
                    input.onChange(selectedId);
                    onChange('typeOfLicense', selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default TypeOfLicense;
